
export interface QcReportMetadata {
  id: string;
  title_Code: string;
  current_user: string;
  qcName: null;
  resolution: string;
  noofQCCycle: number;
  noofQcRejectFrame: number;
  noofFQACycle: number;
  noofFQARejectFrame: number;
  reel_Name: string;
  shot_Name: string;
  start_Frame: string;
  end_Frame: string;
  total_Frame: string;
}

export type titleWiseDataType = {
  title_Code: string;
  title_Name: string;
  client_Code: string | null;
  client_Name: string | null;
  team: string | null;
  location: string | null;
  est_Hr: string | null;
  fresh_YettoStart: number;
  fresh_Pending: number;
  qC_YettoStart: number;
  qC_Pending: number;
  fqA_YettoStart: number;
  fqA_Pending: number;
  cqC_YettoStart: number;
  cqC_Pending: number;
  cC_Pending: number;
  cC_YettoStart: number;
  wave_Pending: number;
  wave_YettoStart: number;
  approved_Frames: number;
  tot_Frames: number;
  complete_per: number;
  deadline: string | null;
  bind_Hr: string | null;
  status: string | null;
  expt_delv_date: string | null;
  actual_Delivery_Date: string | null;
  metadata: string | null;
};

export type reelWiseDataType = {
  title_Code: string;
  reel_No: string;
  total_Frame: number;
  pending_With_Operator: number;
  pending_With_QC: number;
  pending_With_FQA: number;
  pending_With_CC: number;
  pending_With_Wave: number;
};

export type plWiseDataType = {
  title_Code: string;
  cluster_Name: string;
  total_Frame: number;
  pending_With_Operator: number;
  pending_With_QC: number;
  pending_With_FQA: number;
  pending_With_CC: number;
  pending_With_Wave: number;
};
export type rejectHistoryType = {
  titleName: string;
  title_Code: string;
  shot_Name: string;
  total_Frame: number;
  defect: {
    rejectby: string;
    defects_Type: string;
    sDefect_SF: number;
    sDefect_EF: number;
    sDefect_TF: number;
    position: string;
    severity: string;
  }[];
};
export type defectData = {
  reject_Date: string;
  title_Code: string;
  team: string;
  operator_Employee_ID: string;
  operator_name: string;
  quality_ID: string;
  quality_name: string;
  work_Type: string;
  resolution: string;
  reel_Name: string;
  shot_Name: string;
  start_Frame: number;
  end_Frame: number;
  total_Frame: number;
  error_St_Frame: number;
  error_end_Frame: number;
  error_total_Frame: number;
  position: string;
  typeoferror: string;
  severity: string;
};

export type NFAIDefectData = {
  reject_Date: string;
  film_Title: string;
  operator_Employee_ID: string;
  operator_name: string;
  quality_ID: string;
  quality_name: string;
  work_Type: string;
  reel_No: string;
  shot_No: string;
  start_Frame: string;
  end_Frame: string;
  total_Frame: string;
  error_St_Frame: string;
  error_end_Frame: string;
  error_total_Frame: string;
  position: string;
  typeoferror: string;
  severity: string;
  amPristine:string,
  resolution:string;
  location:string;
}

export const defectOrder: (keyof NFAIDefectData)[] = [
  "reject_Date",
  "film_Title",
  "operator_Employee_ID",
  "operator_name",
  "quality_ID",
  "quality_name",
  "work_Type",
  "reel_No",
  "shot_No",
  "start_Frame",
  "end_Frame",
  "total_Frame",
  "error_St_Frame",
  "error_end_Frame",
  "error_total_Frame",
  "position",
  "typeoferror",
  "severity",
  "amPristine",
  "resolution",
  "location",
];

export type manDaysType = {
  title: string;
  employee: string;
  description: string;
  total_Frame: number;
  estimate_Matte_Paint_Mandays: number;
  actual_Matte_Paint_Mandays: string;
  estimate_Paint_Mandays: number;
  actual_Paint_Mandays: string;
  estimate_Comp_Mandays: number;
  actual_Comp_Mandays: string;
  estimate_Roto_Mandays: number;
  actual_Roto_Mandays: string;
  estimate_3D_Mandays: number;
  actual_3D_Mandays: string;
  metadata: string;
};

export type operatorPerformanceType = {
  title_code: string;
  pl_Name: string;
  emp_Id: string;
  emp_Name: string;
  reel_Name: String;
  work_Type: string;
  shot_Name: string;
  resolution: string;
  complexity_Level: string;
  target_Frame: number;
  actual_Frame: number;
  actual_Hours: string;
  extra_Hours: string;
  actual_Framepermin: number;
  total_Reject_Frame: number;
  startdate: string;
  endDate: string;
};

export type performanceReportDateWise = {
    employee_id: string,
    employee_Name: string,
    title_Code: string,
    actual_Hours: string,
    extra_Hours: string,
    fresh_Frame: number,
    correction_Frame: number,
    process_Date: string
}

export type artistPerformanceReportDateWise = { 
    employee_id: string,
    employee_Name: string,
    title_Code: string,
    actual_Hours: string,
    extra_Hours: string,
    poly_Creation_Frame: number,
    colorization_Frame: number,
    number_of_Reject_QC: number,
    process_Date: string
}

export type artistPerformanceReportTitleWise = { 
  employee_id: string,
  employee_Name: string,
  title_Code: string,
  reel_Name: string,
  shot_Name: string,
  actual_Hours: string,
  extra_Hours: string,
  poly_Creation_Frame: number,
  colorization_Frame: number,
  number_of_Reject_QC: number
}

export type colorizationMonthlyProductivityReport = {
  emp_ID: string,
  emp_Name: string,
  designation: string,
  team: string,
  cluster_Lead: string,
  sum_of_Frames: number,
  sum_of_Act_Target: number,
  sum_of_Reject_Frame: number,
  artifacts_Rejected_Frames: number,
  productivity: string,
  quality_Percentage: string,
  artifacts_Rejected_Frames_Percentage: string,
  working_Days: number,
  present_Days: number,
  leaves: number,
  attendance_Percentage: string,
  tenure: string,
  months: number,
  efficency: string,
  attendance_Hours: number,
  hC_Hours: number,
  hC_Adherence: string,
  scorecard: string,
  rank: number,
  points: string
}

export type hoursMissingEmployeeDetailsReport = {
  manager_Name: string,
  cluster_Name: string,
  mTD_Count: number,
  day_Count: number
}

export type dayWiseHoursReport = {
  hour: any;
  date: string
  processLead: string
  clusterName: string
  employee_ID: string
  employee_Name: string
  WorkingHours: string
  ExtraHours: string
  TotalHours: string
  isAchieved: boolean
}

export type titleProductivityReportInfo = {
  employeeID: string
  employeeName: string
  project_Name: string
  approved_Frame: number
  totalHours: number
  date_of_Floor: string
  current_Date: string
  tenure: string
  efficency: string
  total_frame: number
  est_Hour: number
  target_frame: number
  actual_Target: number
  rejectFrame: number
  artifactFrame: number
  productivity: string
  quality: string
  qualityofartifact: string
}

export type titleProductivityReportInfobyDate = {
  employee_Id: string
  employee_Name: string
  project_Name: string
  approval_Frames: number
  total_Hours: string
  dof: string
  current: string
  tenure: string
  efficency: string
  est_Hour: number
  total_Framess: number
  target: number
  actualTarget: number
  productivity_percentage: string
  sum_of_Rejected_Frames: number
  quality_percentage: string
  artifacts_Rejected_Frames: number
  artifacts_Rejection_percentage: string
};

export type smartDeleteListData = {
  id: string
  title_Code: string
  shot_Name: string
  start_Number: number
  end_Number: number
  total_Number: number
  current_SubTask: string
  status: string
};

export type CRMAssetTrack = {
  id: string
  createDate: string
  title: string
  company: string
  building: string
  department: string
  location: string
  category: string | string[]
  make_Or_Model_No: string
  model_Sn: string
  asset_Moved_To: string
  handover_date: string
  remarks: string
  isReceived: boolean
}

export type createCRMAsset = {
  title: string
  company: string
  building: string
  department: string
  location: string
  category: string | string[]
  make_Or_Model_No: string
  model_Sn: string
  asset_Moved_To: string
  remarks: string
  receiving_date:Date;
  handover_date: Date;
}

export const createCRMAssetInitialState = {
  title: '',
  company: '',
  building: '',
  department: '',
  location: '',
  category: [],
  make_Or_Model_No: '',
  model_Sn: '',
  asset_Moved_To: '',
  receiving_date: new Date(),
  handover_date: new Date(),
  remarks: '',
};
export type departmentCRMAsset = {
  id: string
  createDate: string
  title: string
  company: string
  building: string
  department: string
  location: string
  category: string | string[]
  make_Or_Model_No: string
  model_Sn: string
  asset_Moved_To: string
  receiving_date:Date;
  handover_date: Date;
  isReceived: boolean
  remarks: string
}

export type cutliststatusreport = {
  leadId: string;
  employee_ID: string;
  employee_Name: string;
  title_Code: string;
  reel_Name: string;
  shot_Name: string;
  resolution: string;
  start_Frame: string;
  end_Frame: string;
  total_Frame: string;
  qC_Approved:string;
  fqA_Approved:string;
  cqC_Approved:string;
  title_Status: string;
  owner: string;
};
export type titleCode = {
  titlecode: string;
};

export type qcperformacedata = {
  empId: string;
  empName: string;
  titleCode: string;
  dustbustingQC_Frame: number;
  qcFrame: number;
  fqaFrame: number;
  cqcFrame: number;
  waveFrame: number;
  ccFrame: number;
  qc_CorrectionFrame: number;
  dustbustingqc_CorrectionFrame: number;
  fqa_CorrectionFrame: number;
  cqc_CorrectionFrame: number;
  wave_CorrectionFrame: number;
  cc_CorrectionFrame: number;
  actual_Hours: string;
  extra_Hours: string;
  actual_Framepermin: string;
  inTime: string;
  outTime: string;
};

export type empid = {
  pcemployeeId: string;
};

export interface ReportDetailsItem {
  [key: string]: string | number; // Assuming all values are either strings or numbers
}

export type ClusterCapacity = {
  cluster: string;
  billable_Head_Count: number;
  month_Working_Dates: number;
  attendance: string;
  average_Efficiency: string;
  month_Capacity_Hours: number;
  month_Utilized_hours: number;
  month_Extra_Hours: number;
  month_Total_Hours: number;
  month_Remaining_Hours: number;
  per_Day_Capacity_Hours: number;
  per_Day_Average_Utilized_hours:number;
  between_Dates_Capacity_Hours: number;
  between_Dates_Utilized_hours: number;
  between_Dates_Extra_Hours: number;
  betweenDate_Total_Hours: number;
};
export type Capacityindividual = {
  employeeId: string;
  employeeName: string;
  cluster: string;
  efficiency: string;
  tenure: string;
  numberofworkingDay: number;
  attendance: string;
  monthCapacityHours: number;
  workingHours: number;
  extraWorkingHrs: number;
  totalWorking:number;
  remainingHrs: number;
};
export type ClusterTenure={
  ClusterName:string;
  oneToThreeMonth:number;
  fourToSixMonth:number;
  sevenTotwelveMonth:number;
  oneToTwoYears:number;
  twoToThreeYears:number;
  threeToFourYears:number;
  fourFiveYears:number;
  fivePlusYears:number;
  grandTotal:number;
}
export type DaywiseHourAnalysis = {
  date: string;
  titlecode: string;
  clusterName: string;
  processLead: string;
  employee_ID: string;
  employee_Name: string;
  workingHours: string;
  extraHours: string;
  totalHours: string;
  isAchieved:boolean;
};

export type RestorationProductivity={
  employee_Id: string;
  employee_Name: string;
  project_Name: string;
  approval_Frames: string;
  total_Hours: string;
  dof: string;
  current: string;
  tenure: string;
  efficency: string;
  est_Hour: string;
  total_Framess: string;
  target: string;
  actualTarget: string;
  productivity_percentage: string;
  sum_of_Rejected_Frames: string;
  quality_percentage: string;
  artifacts_Rejected_Frames: string;
  artifacts_Rejection_percentage: string;
};


export type monthlyProductivitydata = {
emp_ID: string; 
emp_Name: string;
designation: string;
team: string;
cluster_Lead: string;
sum_of_Frames: number;
sum_of_Act_Target: number;
sum_of_Reject_Frame: number;
artifacts_Rejected_Frames: number;
productivity: string;
quality_Percentage: string;
artifacts_Rejected_Frames_Percentage: string;
working_Days: number;
present_Days: number;
leaves: number;
attendance_Percentage: string;
hC_Adherence: string;
tenure: string;
months: number;
efficency: string;
attendance_Hours: number;
hC_Hours: string;
scorecard: string;
rank: string;
points: string;

};

export type TitleWiseDashboard = {
  title_Name: string; 
  title_Code: string;
  resolution: string;
  client_Name: string;
  start_date: string;
  delivery_date: string;
  allocated_Frames:number;
  approved_Frames: number;
  qC_Rejected_Frames: number;
  fqA_Rejected_Frames: number;
  cqC_Rejected_Frames: number;
  complete_Percentage: string;
  estimate_Hour: number;
  production_Hours: number;
  quality_Hours: number;
  total_Hours: number;
  total_Efficiency_Hours: number;
  titlestatus:string;
  pcrStatus:string;
  frrStatus:string;
  };
export type pcrReportBasic = {
  client : string; 
  reels : string; 
  shots : string; 
  cluster : string;
  end_Date : string;
  qcFrame : number;
  fqaFrame: number;
  pcrNumber:string;
  pcrDate:string;
};
export type pcrComments = {
  indexNumber:number;
  titleCode : string; 
  int_Ext : string; 
  description : string; 
  action_Taken : string;
};
export type pcrCommentsPayload = {
  titleCode : string; 
  int_Ext : string; 
  description : string; 
  action_Taken : string;
};
export type pcrReportdetails = {
Titlecode:string;
level:string;
Input_Metrial:string;
OutPut_Metrial:string;
IM_Nos:string;
OM_Nos:string;
Our_OM_Nos:string;
Lob_Split_up:string;
Location_Split_up:string;
Work_Advice:string;
Contract_Review:string;
Analysis_Report:string;
QA_Feedback_Tracker:string;
Estimation_to_Client:string;
Content_Report:string;
Shot_Estimate_Report:string;
Project_allocation_Sheet:string;
Daily_Tracker:string;
Estimation_Report:string;
Final_Restoration_Report:string;
LTO_Log:string;
Detection_Approval_reacd:string;
Project_Brief:string;
QC_Feedback_Tracker:string;
Project_Plan_and_Tracker:string;
No_of_ReworkingHrs:string;
DRE_QC:string;
DRE_Client:string;
Customer_Complaints:string;
notes:string;
improvements:string;
actualDeliveryDate:string;
};
export type pcrReportinforamation = {
  pcrNumber:string;
  pcrDate:string;
  client:string;
  reels:string;
  shots:string;
  cluster:string;
  end_Date:string;
  qcFrame:number;
  fqaFrame:number;
  titlecode:string;
  level:string;
  input_Metrial:string;
  outPut_Metrial:string;
  iM_Nos:string;
  oM_Nos:string;
  our_OM_Nos:string;
  lob_Split_up:string;
  location_Split_up:string;
  work_Advice:string;
  contract_Review:string;
  analysis_Report:string;
  qA_Feedback_Tracker:string;
  estimation_to_Client:string;
  content_Report:string;
  shot_Estimate_Report:string;
  project_allocation_Sheet:string;
  daily_Tracker:string;
  estimation_Report:string;
  final_Restoration_Report:string;
  ltO_Log:string;
  detection_Approval_reacd:string;
  project_Brief:string;
  project_Plan_and_Tracker:string
  qC_Feedback_Tracker:string;
  no_of_ReworkingHrs:string;
  drE_QC:string;
  drE_Client:string;
  notes:string;
  customer_Complaints:string;
  improvements:string;
  actualDeliveryDate:string;
  dayDifferent:number;
  };
  export type frrReportAddress = {
    titleCode:string;
    reelName:string;
    startFrame:number;
    endFrame:number;
    totalFrame:number;
    comments:string;
  };
  export type defectType ={
    key:number;
    text:string;
    value:boolean;
  };
  export type FrrInformData={
    titleCode:string;
    inputFrame:string;
    noOfReel:string;
    outputFrame:string;
    clientRequirementLevel:string;
    resolution:string;
    generalSummary:string;
  };

  export type getfrrReportAddress = {
    addressNo:number;
    titleCode:string;
    reelName:string;
    startFrame:number;
    endFrame:number;
    totalFrame:number;
    comments:string;
    clusterName:string;
  };

  export type getFrrInformData={
    ffrNo:number;
    titleCode:string;
    ffrDate:string;
    inputFrame:string;
    noOfReel:string;
    outputFrame:string;
    clientRequirementLevel:string;
    resolution:string;
    generalSummary:string;
    updatedBy:string;
  };

  export type honeyCombStatusReport={
    clusterID:string;
    clusterName:string;
    employee_ID:string;
    employee_Name:string;
    first_startTime:string;
    liveStartTime:string;
    cutlistHold:string;
    workingHours:string;
    status:string;
    ispresent:boolean;
  };
  export type operationReport={
    fresh_or_correction:string;
    client:string;
    titleName:string;
    teams:string;
    fps:string;
    estimateHours:string;
    actualHours:string;
    recd_Date:string;
    start_date:string;
    schedule_date:string;
    date_of_completion_in_production:string;
    pcR_was_submitted:string;
    total_Frames:string;
    complexity:string;
    qC_Rejected_Frames:string;
    qA_Rejected_Frames:string;
    remarks:string;
    titlecode:string;
  };
  export type OperationReportClustorDetails={
    headName:string;
    clusterName:string;
    titleName:string;
    titleCode:string;
    resolutionWithFPS:string;
    estimateHour:number;
    actualHour:number;
    recdDate:string;
    startDate:string;
    scheduleDate:string;
    endDate:string;
    tat:number;
    totalFrame:number;
    qcRejectFrame:number;
    qaRejectFrame:number;
  };

  export type ClustorDetailsSummary={
    headName:string;
    clusterName:string;
    titleCount:number;
    qcRejectFrameSummary:number;
    qaRejectFrameSummary:number;
    estimateHour:number;
    actualHour:number;
    totalFrame:number;
  };

  export type ClustorHeadSummary={
    headName:string;
    titleCount:number;
    qcRejectFrameSummary:number;
    qaRejectFrameSummary:number;
    estimateHour:number;
    actualHour:number;
    totalFrame:number;
  };
  export type ProductivityReportbyTitleBreakUp={
    employee_Id:string;
    employee_Name:string;
    project_Name:string;
    approval_Frames:number;
    total_Hours:string;
    efficiency_Hours: string;
    dof:string;
    current:string;
    tenure:string;
    efficency:string;
    est_Hour:number;
    total_Framess:number;
    target:number;
    actualTarget:number;
    productivity_percentage:string;
    sum_of_Rejected_Frames:number;
    quality_percentage:string;
    artifacts_Rejected_Frames:number;
    artifacts_Rejection_percentage:string;
    
  };
  export type dropTitleCode={
    key:number;
    text:string;
    value:string;
  };

  export type FrrInformationTitleDetails = {
    title_Name: string; 
    input_Format: string;
    out_Format: string;
    client_Requirement_Level_Requested: string;
    no_of_Reels: number;
    aspect_Ratio:string;
    total_Frames: number;
    };